import React, { Component } from "react";
import { Button } from "antd";

class AreaBox extends Component {
  render() {
    const {
      data: { width, height, startX, startY },
      onClick
    } = this.props;
    return (
      <div
        className="area-box"
        onClick={onClick}
        style={{
          width: `${width}px`,
          height: `${height}px`,
          left: `${startX}px`,
          top: `${startY}px`
        }}
      >
        <Button
          onClick={onClick}
          className="area-box__link-button"
          type="primary"
          shape="circle"
          icon="link"
          size="small"
        />
      </div>
    );
  }
}

export default AreaBox;



// WEBPACK FOOTER //
// ./src/theme/AreaBox/index.js